import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrFormikField, {
  SR_FIELD_THEME_WHITNEY,
} from 'client/components/SrFormikField';

const SrBuyerSideAgentFormContainer = ({
  formFields,
  formikBag,
  stepDefinitionUI,
}) => {
  return (
    <SrBox marginBottom={stepDefinitionUI.noStaticFooter ? '10px' : '60px'}>
      {formFields.map((formField) => (
        <SrFormikField
          formField={formField}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_WHITNEY}
          key={formField.id}
        />
      ))}
    </SrBox>
  );
};

SrBuyerSideAgentFormContainer.propTypes = {
  formFields: PropTypes.array.isRequired,
  formikBag: PropTypes.object.isRequired,
};

SrBuyerSideAgentFormContainer.displayName = 'SrBuyerSideAgentFormContainer';

export default SrBuyerSideAgentFormContainer;
